<ng-container *transloco="let t; read: 'findMyAgent.address'">
  @if (searchStore.searchType$ | async; as searchType) {
    <label class="text-heading-2 text-steel-100 mb-4 block">{{
      t(searchType === 'StreetAddress' ? 'address.title' : 'location.title')
    }}</label>
    <div class="mb-4">
      <mat-radio-group (change)="onSwitch($event)" aria-label="Select an option" color="primary">
        <mat-radio-button [value]="'Locations'" [checked]="(searchStore.searchType$ | async) === 'Locations'">{{
          t('location.switch')
        }}</mat-radio-button>
        <mat-radio-button class="md:ml-4" [value]="'StreetAddress'" [checked]="(searchStore.searchType$ | async) === 'StreetAddress'">{{
          t('address.switch')
        }}</mat-radio-button>
      </mat-radio-group>
    </div>
    <rma-search-auto-complete
      [autoFocus]="true"
      [selectedSearchType]="searchType"
      [results]="searchStore.locationSearchResults$ | async"
      [placeholder]="'findMyAgent.address.' + (searchType === 'StreetAddress' ? 'address.placeholder' : 'location.placeholder') | transloco"
      (update)="searchStore.locationSearch($event)"
      (viewedAll)="searchStore.locationViewMore()"
      (selected)="onLocationSelected($event.option.value, searchType)" />
  }
</ng-container>
